<ng-container *ngIf="isDataSetLoaded$ | async; else loading">
  <mat-card appearance="outlined" class="mat-elevation-z1 kpi-pacing-gauge-element">
    <mat-card-title>
      <div class="pacing-title">{{ cardTitle }}</div>
      <div class="pacing-actions">
        <button mat-icon-button title="Toggle details view" (click)="toggleFlip()">
          <mat-icon>{{ isFlipped ? 'donut_large' : 'list_alt' }}</mat-icon>
        </button>
        <button mat-icon-button title="Help" [matMenuTriggerFor]="helpOptions" *ngIf="!!settings?.helpTextKey">
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>
      <mat-menu #helpOptions="matMenu">
        <button mat-menu-item (click)="openHelpTextClicked()">Help</button>
      </mat-menu>
    </mat-card-title>

    <mat-card-content>
      <div class="pacing-card-shell" [class.is-flipped]="isFlipped">
        <div class="pacing-card-inner">
          <section class="pacing-face pacing-front">
            <div
              class="gauge-wrapper"
              (mouseenter)="onGaugeMouseEnter()"
              (mouseleave)="onGaugeMouseLeave()"
            >
              <svg class="gauge-svg" viewBox="0 0 220 220" role="img" aria-label="KPI pacing gauge">
                <circle
                  class="gauge-track"
                  cx="110"
                  cy="110"
                  [attr.r]="gaugeRadius"
                  [attr.stroke-width]="gaugeStrokeWidth"
                  [attr.stroke]="gaugeTrackColor"
                ></circle>
                <circle
                  class="gauge-value"
                  cx="110"
                  cy="110"
                  [attr.r]="gaugeRadius"
                  [attr.stroke-width]="gaugeStrokeWidth"
                  [attr.stroke]="stateColor"
                  [attr.stroke-dasharray]="gaugeCircumference"
                  [attr.stroke-dashoffset]="gaugeDashOffset"
                ></circle>
              </svg>

              <div class="gauge-metrics">
                <div class="gauge-metric-label">{{ metricLabel }}</div>
                <div class="gauge-metric-value" [style.color]="stateColor">{{ actualDisplayValue }}</div>
                <div class="gauge-target-row">
                  <span class="gauge-target-copy">Target:</span>
                  <span class="gauge-target-value">{{ targetDisplayValue }}</span>
                </div>
              </div>

              <div class="gauge-hover-panel" *ngIf="showHoverDetails">
                <div class="hover-insight" *ngFor="let insight of hoverInsights">
                  <div class="hover-insight-label">{{ insight.label }}</div>
                  <div class="hover-insight-value">
                    <span class="hover-insight-lead" [ngClass]="getToneClass(insight.tone)">{{ insight.leadValue }}</span>
                    <span>{{ insight.supportingText }}</span>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section class="pacing-face pacing-back">
            <div class="back-divider"></div>
            <div class="back-section-title">Performance Summary</div>
            <div class="back-summary-row">
              <span class="back-summary-label">MTD:</span>
              <span class="back-summary-value tone-positive">{{ flippedSummaryMtdValue }}</span>
              <span class="back-summary-copy">of goal</span>
            </div>
            <div class="back-summary-row">
              <span class="back-summary-label">Pace vs. Benchmark:</span>
              <span class="back-summary-value" [ngClass]="getToneClass(flippedSummaryPaceTone)">{{ flippedSummaryPaceValue }}</span>
            </div>

            <div class="back-divider"></div>
            <div class="back-section-title">Key Metrics</div>
            <div class="back-metrics">
              <div class="back-metric-row" *ngFor="let metric of supplementalMetrics">
                <span class="back-metric-label">{{ metric.label }}</span>
                <span class="back-metric-pill" [ngClass]="getToneClass(getSupplementalMetricValueTone(metric))">{{ metric.value }}</span>
                <span
                  class="back-metric-pill"
                  *ngIf="getSupplementalMetricTrendDisplay(metric) as trendDisplay"
                  [ngClass]="getToneClass(getSupplementalMetricTrendTone(metric))"
                >
                  {{ trendDisplay }}
                </span>
              </div>
            </div>
          </section>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</ng-container>

<ng-template #loading>
  <mat-card appearance="outlined" class="mat-elevation-z1 kpi-pacing-gauge-element">
    <mat-card-title>
      <div class="title-placeholder" syncPulse></div>
    </mat-card-title>
    <mat-card-content>
      <div class="gauge-placeholder" syncPulse></div>
    </mat-card-content>
  </mat-card>
</ng-template>
